module.exports = __webpack_public_path__ + "public/adminIcons/siteSetting.svg?f45d8651";